module.exports = __webpack_public_path__ + "static/media/GAME ROOM SMALL.d856fdf0.png";